import { Divider, Row } from 'antd'
import CategorySegmentList from 'app/components/Core/CategorySegment/List'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useRestriction } from 'app/lib/hooks/useRestriction'
import React, { Fragment } from 'react'

import { CollectionProps } from '../convention'
import CategoryListItem from './ListItem'

type Props = {
  onCategorySegmentClick?: (categorySegment: ICategorySegment) => void
  onCategoryClick?: (category: ICategory) => void
}

const List: React.FC<CollectionProps<ICategory, Props>> = ({
  collection,
  props: { onCategorySegmentClick, onCategoryClick } = {}
}) => {
  const { restricted } = useRestriction({
    allowFor: ['admin', 'manager', 'member', 'accounting', 'delivery_contact']
  })
  const { tRecordType } = ToolBox.useString()

  return (
    <Row gutter={[0, 48]}>
      <KCol span={24}>
        <Row gutter={[0, 12]}>
          <KCol span={24}>
            <span className="text-muted">{tRecordType(RecordType.category)}</span>
          </KCol>
          <KCol span={24}>
            {collection.map((item) => (
              <CategoryListItem
                key={item.id}
                member={item}
                props={{ onClick: () => onCategoryClick?.(item) }}
              />
            ))}
            <Divider className="my-0" />
          </KCol>
        </Row>
      </KCol>
      <KCol span={24}>
        <Row gutter={[0, 12]}>
          {collection.map((category) => (
            <Fragment key={category.id}>
              <KCol span={24}>
                <span className="text-muted">{category.label}</span>
                <If condition={!restricted}>
                  <span className="text-muted pull-right">
                    {tRecordType(RecordType.category_segment, 'availability')}
                  </span>
                </If>
              </KCol>
              <KCol span={24}>
                <CategorySegmentList
                  collection={category.category_segments}
                  props={{ onRowClick: onCategorySegmentClick, showAvailability: !restricted }}
                />
              </KCol>
            </Fragment>
          ))}
        </Row>
      </KCol>
    </Row>
  )
}

export default List
